import './style.scss'
import { useRef, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import utility from 'src/utils/utility'
import ApiContext from 'src/provider/API/call-service';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import { AppSpan, AppText, Circle, CustomContainer, FlexRow, GridContainer, PageTitle, PageWrapper } from 'src/style';
import { Filter, HorizontalScroll } from 'src/component';
import { useEffect } from 'react';
import helpers from 'src/utils/helpers';
import { Product } from 'src/model';
import { dashboardApps } from 'src/utils/mock-data'

const infoPeriods = ['12 months', '3 months', '30 days', '7 days', '24 hours', 'Custom']


const Dashboard: React.FC = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {info: {authToken}, setInfoProperty} = useContext(AppInfoContext)
    const [period, setPeriod] = useState(infoPeriods[0])
    const [mostInstalled, setMostInstalled] = useState<Array<any>>([])
    const [leastInstalled, setLeastInstalled] = useState<Array<any>>([])
    const [view, setView] = useState('')

    const filterDataRef = useRef({})

    useEffect(() => {
        filterDataRef.current = helpers.getStartAndEndDate(period)
        
        if (authToken) getProductsBySection()
    }, [authToken])

    function getProductsBySection () {
        handleFetchProducts()
        handleFetchProducts('ASC')
    }

    async function handleFetchProducts (sortOrder: string = 'DESC', sortColumn: string = 'Installation') {
        const response = await API.getProducts({pageNumber: 1, pageSize: 10, sortColumn, sortOrder, ...filterDataRef.current})
        if (response) {
            if (sortColumn === 'Installation' && sortOrder === 'DESC') setMostInstalled(response.data)
            else if (sortColumn === 'Installation' && sortOrder === 'ASC') setLeastInstalled(response.data)
        }
    }

    function handleInfoPeriodChange (duration: string) {
        setPeriod(duration)
        if (duration === 'Custom') {
            setView('filter')
        }
        else {
            filterDataRef.current = helpers.getStartAndEndDate(duration)
            getProductsBySection()
        }
    }

    async function handleViewProduct (product: Product) {
        await setInfoProperty('selectedProduct', product)
        navigate(`/admin/administration/product/${product.id}`)
    }

    return (
        <>
            <PageWrapper>
                <FlexRow 
                    justifyContent="space-between"
                    wrap='wrap' gap="2.5" 
                >
                    <PageTitle 
                        color='#101828' textSize='3' fontWeight="500"
                    >
                        Dashboard
                    </PageTitle>
                    <FlexRow width='auto' sizeUnit='' wrap='wrap'>
                        {
                            infoPeriods.map((item: string, index: number) => {
                                return (
                                    <GridContainer
                                        bgColor={item === period ? '#E7F6F5' : 'transparent'}
                                        radius='0.6' width='9.3' height='3.6'
                                        key={index}
                                        onClick={() => handleInfoPeriodChange(item)}
                                    >
                                        <AppSpan
                                            color={item === period ? '#0A756F' : '#667085'}
                                            fontWeight="500" cursor='pointer'
                                        >
                                            {item}
                                        </AppSpan>
                                    </GridContainer>
                                )
                            })
                        }
                    </FlexRow>
                </FlexRow>
                <CustomContainer topMargin='2.5'>
                    <CustomContainer>
                        <AppSpan color='#101828' textSize='2' fontWeight="500">
                            Most Installed Apps
                        </AppSpan>
                        <HorizontalScroll>
                            <FlexRow 
                                gap='1.5'
                                alignItems='flex-start'
                                style={{minWidth: 'fit-content'}}
                            >
                                {
                                    mostInstalled?.map((item, index) => {
                                        return (
                                            <CustomContainer
                                                key={index}
                                                width='21.48' minHeight='11'
                                                radius='0.8' borderColor='#EAECF0'
                                                shadow='0px 1px 2px 0px #1018280F, 0px 1px 3px 0px #1018281A'
                                                padding='2'
                                                onClick={() => handleViewProduct(item)}
                                            >
                                                <FlexRow gap='1'>
                                                    <Circle 
                                                        size="5" bgColor='#ffffff' 
                                                        borderColor='#EAECF0'
                                                        className='fixed-flex-shape'
                                                        style={{overflow: 'hidden'}}
                                                    >
                                                        <Circle 
                                                            size='4'
                                                            style={{overflow: 'hidden'}}
                                                        >
                                                            <img 
                                                                src={item.logoUrl} 
                                                                className='img-covered' 
                                                                style={{objectFit: 'contain'}} 
                                                            />
                                                        </Circle>
                                                    </Circle>
                                                    <AppSpan 
                                                        color='#101828' textSize='1.6' fontWeight="500"
                                                        style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}
                                                    >
                                                        {item.name}
                                                    </AppSpan>
                                                </FlexRow>
                                                <AppText 
                                                    topMargin='1.5'
                                                >
                                                    installed by 
                                                    <AppSpan 
                                                        color='#409089' fontWeight="600"
                                                        leftPadding='1'
                                                    >
                                                        {item.productStatistic?.installation} institutions
                                                    </AppSpan>
                                                </AppText>
                                            </CustomContainer>
                                        )
                                    })
                                }
                            </FlexRow>
                        </HorizontalScroll>
                    </CustomContainer>
                    <CustomContainer topMargin='2'>
                        <AppSpan color='#101828' textSize='2' fontWeight="500">
                            Least Installed Apps
                        </AppSpan>
                        <HorizontalScroll>
                            <FlexRow 
                                gap='1.5'
                                alignItems='flex-start'
                                style={{minWidth: 'fit-content'}}
                            >
                                {
                                    leastInstalled?.map((item, index) => {
                                        return (
                                            <CustomContainer
                                                key={index}
                                                width='21.48' minHeight='11'
                                                radius='0.8' borderColor='#EAECF0'
                                                shadow='0px 1px 2px 0px #1018280F, 0px 1px 3px 0px #1018281A'
                                                padding='2'
                                                onClick={() => handleViewProduct(item)}
                                            >
                                                <FlexRow gap='1'>
                                                    <Circle 
                                                        size="5" bgColor='#ffffff' 
                                                        borderColor='#EAECF0'
                                                        className='fixed-flex-shape'
                                                        style={{overflow: 'hidden'}}
                                                    >
                                                        <Circle 
                                                            size='4'
                                                            style={{overflow: 'hidden'}}
                                                        >
                                                            <img 
                                                                src={item.logoUrl} 
                                                                className='img-covered' 
                                                                style={{objectFit: 'contain'}} 
                                                            />
                                                        </Circle>
                                                    </Circle>
                                                    <AppSpan 
                                                        color='#101828' textSize='1.6' fontWeight="500"
                                                        style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}
                                                    >
                                                        {item.name}
                                                    </AppSpan>
                                                </FlexRow>
                                                <AppText 
                                                    topMargin='1.5'
                                                >
                                                    installed by 
                                                    <AppSpan 
                                                        color='#409089' fontWeight="600"
                                                        leftPadding='1'
                                                    >
                                                        {item.productStatistic?.installation} institutions
                                                    </AppSpan>
                                                </AppText>
                                            </CustomContainer>
                                        )
                                    })
                                }
                            </FlexRow>
                        </HorizontalScroll>
                    </CustomContainer>
                    <CustomContainer topMargin='2'>
                        <AppSpan color='#101828' textSize='2' fontWeight="500">
                            Highest Revenue Generated Apps
                        </AppSpan>
                        <HorizontalScroll>
                            <FlexRow 
                                gap='1.5'
                                alignItems='flex-start'
                                style={{minWidth: 'fit-content'}}
                            >
                                {
                                    dashboardApps.highestGeneratedRevenue?.map((item, index) => {
                                        return (
                                            <GridContainer
                                                key={index}
                                                width='21.48' minHeight='11'
                                                radius='0.8' borderColor='#EAECF0'
                                                shadow='0px 1px 2px 0px #1018280F, 0px 1px 3px 0px #1018281A'
                                                padding='2'
                                            >
                                                <CustomContainer>
                                                    <FlexRow gap='1'>
                                                        <Circle 
                                                            size="5" bgColor='#ffffff' 
                                                            borderColor='#EAECF0'
                                                            className='fixed-flex-shape'
                                                            style={{overflow: 'hidden'}}
                                                        >
                                                            <Circle 
                                                                size='4'
                                                                style={{overflow: 'hidden'}}
                                                            >
                                                                <img src={item.logo} className='img-covered' />
                                                            </Circle>
                                                        </Circle>
                                                        <AppSpan 
                                                            color='#101828' textSize='1.6' fontWeight="500"
                                                        >
                                                            {item.name}
                                                        </AppSpan>
                                                    </FlexRow>
                                                    <AppText 
                                                        color='#409089' fontWeight="600"
                                                        textSize='1.6' topMargin='1.5'
                                                    >
                                                        ₦{utility.moneyFormat(item.amount)}
                                                    </AppText>
                                                </CustomContainer>
                                            </GridContainer>
                                        )
                                    })
                                }
                            </FlexRow>
                        </HorizontalScroll>
                    </CustomContainer>
                    <CustomContainer topMargin='2'>
                        <AppSpan color='#101828' textSize='2' fontWeight="500">
                            Service Reliability
                        </AppSpan>
                        <HorizontalScroll>
                            <FlexRow 
                                gap='1.5'
                                alignItems='flex-start'
                                style={{minWidth: 'fit-content'}}
                            >
                                {
                                    dashboardApps.serviceReliablity?.map((item, index) => {
                                        return (
                                            <CustomContainer
                                                key={index}
                                                width='21.48' minHeight='11'
                                                radius='0.8' borderColor='#EAECF0'
                                                shadow='0px 1px 2px 0px #1018280F, 0px 1px 3px 0px #1018281A'
                                                padding='2'
                                            >
                                                <FlexRow gap='1'>
                                                    <Circle 
                                                        size="5" bgColor='#ffffff' 
                                                        borderColor='#EAECF0'
                                                        className='fixed-flex-shape'
                                                        style={{overflow: 'hidden'}}
                                                    >
                                                        <Circle 
                                                            size='4'
                                                            style={{overflow: 'hidden'}}
                                                        >
                                                            <img src={item.logo} className='img-covered' />
                                                        </Circle>
                                                    </Circle>
                                                    <AppSpan 
                                                        color='#101828' textSize='1.6' fontWeight="500"
                                                    >
                                                        {item.name}
                                                    </AppSpan>
                                                </FlexRow>
                                                <AppText 
                                                    color='#409089' textSize='1.2'
                                                    bottomMargin='0.5' topMargin='1.5'
                                                >
                                                    <AppSpan 
                                                        color='#409089' textSize='1.2' 
                                                        fontWeight='800' rightPadding='0.3'
                                                    >
                                                        {item.noOfSuccessfulApiCall}
                                                    </AppSpan> 
                                                    Successful Api Calls
                                                </AppText>
                                                <AppText 
                                                    color='#D22626' textSize='1.2'
                                                >
                                                    <AppSpan 
                                                        color='#D22626' textSize='1.2' 
                                                        fontWeight='800' rightPadding='0.3'
                                                >
                                                        {item.noOfFailedApiCall}
                                                    </AppSpan> 
                                                    Failed Api Calls
                                                </AppText>
                                            </CustomContainer>
                                        )
                                    })
                                }
                            </FlexRow>
                        </HorizontalScroll>
                    </CustomContainer>
                </CustomContainer>
            </PageWrapper>
            { view === 'filter' &&
                <Filter
                    type='dashboard'
                    onApplyFilter={getProductsBySection}
                    setFilterData={(data: any) => {filterDataRef.current = data}}
                    close={() => setView('')}
                    top='27'
                />
            }
        </>
    );
}

export default utility.routeData('dashboard', 'Dashboard', <Dashboard/>)


